import { MetadataKeys } from "utils/metadata";
import { FullBaseInfo } from "ez-node-base";
import { MetadataValue } from "@grpc/grpc-js";
import { LITBInfo } from "ez-node-base/lib/sites/litb";
import { isUAT } from "utils/debug";
import Constants from "utils/isomorphismConstant";
import { Platform } from "utils/website";
import { Options as WebapiOptions } from "utils/fetch";

export const generateDomain = function generateDomain(isUat: boolean = false, initDomain: string) {
	if (isUat) {
		return `${initDomain}.65emall.net`;
	}
	return `${initDomain}.lightinthebox.com`;
};
interface GenerateLitbAPIAddressProps extends LITBInfo {
	tPlatform: string;
}
export const generateLitbAPIAddress = function generateLitbAPIAddress({
	tPlatform: platform,
	isuat,
}: Partial<GenerateLitbAPIAddressProps>) {
	isuat = isuat || isUAT();
	platform = platform || Constants.platform;
	const apiDomain = generateDomain(
		isuat,
		platform === Platform.WEB ? `litb-en-web-%SERVICE_TYPE%` : `litb-en-mweb-%SERVICE_TYPE%`,
	);

	let webapiDomain: string;
	if (isuat) {
		webapiDomain = apiDomain.replace("%SERVICE_TYPE%", "api.kdev0-api");
	} else {
		webapiDomain = apiDomain.replace("%SERVICE_TYPE%", "api");
	}
	webapiDomain = webapiDomain.replace("..", ".");
	const protocal = "https";
	return `${protocal}://${webapiDomain}/api`;
};
interface ApiBaseInfo extends Partial<FullBaseInfo> {
	onlyFetch?: boolean;
}
interface Options {
	meta?: Map<MetadataKeys, MetadataValue>;
	baseInfo?: Partial<ApiBaseInfo>;
}
export default function webapi<T>(method: string, params: any, options?: Options): Promise<T> {
	if (__SERVER__ && !options?.baseInfo?.onlyFetch) {
		const grpc = require("../server/grpcapi").default;
		return grpc(method, params, options.meta);
	}
	const api = require("utils/fetch").default;
	const { baseInfo } = options;
	const platform: string = baseInfo?.platform || "web";
	const apiDomain = `${generateLitbAPIAddress({
		isuat: baseInfo?.isuat || isUAT(),
		tPlatform: platform,
	})}`;
	const apiOptions:WebapiOptions = { apiDomain, cookie: options?.baseInfo?.cookie };
	return api(method, params,  apiOptions);
}
